import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import SubString from 'add-ellipsis';
import Dialog from "material-ui/Dialog";
import RaisedButton from 'material-ui/RaisedButton';
import { CancelButton} from "../../../../../../../../components/buttons";
import { change, Field, reduxForm, reset } from 'redux-form';
import Alert from "react-s-alert";
import { PatientSkillAcqActiveTargetListNewFlow, getPatientSkillAcqTaskAnalysislist, selectedProgramForTargetAction, savePatientSkillsAcquisitionCollectedData, deletePatientSkillAcqPreviousTrial_NewFlow, getPatientSkillAcqPreviousTrialistNewFlow, SavePatientRecordFrequencyData, isRecordDurationStartSkAq, isRecordDurationRenderTrueSkAq, SavePatientRecordDurationData} from "./actions/targetsActionNewFlow";
import { SetProgramIDsForSkillAcqTargetAction } from '../programs/actions/programsActions';
import { getPatientPromptCodeListToCollectData } from '../../../../../DataCollection/SetUp/promptCodes/actions/PromptCodeActions';
import SortingCustom from '../../../../../../../../components/SortingCustom';
import DTTModal from './DttModal';
import TaskAnalysisModal from './TaskAnalysisModal';
import TodaysDTTDataModal from './TodaysDTTDataModal';
import TodaysTADataModal from './TodaysTADataModal';
import Tooltip from '../../../../../../../../components/Tooltip';
import { renderAutoCompleteScheduling, renderAutoCompleteSingleSelect, renderCheckBox, renderTextArea } from '../../../../../../../../components/reduxFields';
import _, { delay } from 'lodash';
import TargetInstructionModal from './TargetInstructionModal';
import Timer from '../targets/Timer';
import { alertConfirmation } from '../../../../../../../../actions/utilAction';
// import TodaysDataModal from './TodaysDataModal';
import TodaysData from './TodaysData';
import DTTGraphModal from './DTTGraphModal';
import TAGraphModal from './TAGraphModal';
import FrequencyGraphModal from './FrequencyGraphModal';
import DurationGraphModal from './DurationGraphModal';

class SkillAcqActiveTargetsNewFlow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            creadteDate: props.creadteDate,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            statusId: null,
            openDttModal: false,
            openTaskAnalysisModal: false,
            openTodaysDTTDataModal: false,
            openTodaysTADataModal: false,
            openTargetInstructionModal: false,
            openTodaysDataModal: false, // for todays data modal
            targetInstructionDetails: '',
            targetObj: {},
            filteredSteps: [],
            selectedActiveProgramIds: props.ProgramIdsForTargetListingApplicationState,         
            statusName: [],
            targetType: [],
            targetId: [],
            sd:[],
            targetInstructions: [],
            programInstructions: [],            
            promptCodeNameId: '',
            todayCompletedTrails: [],
            desiredDailyTrials: [],
            prevData: [],
            skillAquisitionTargetId: [],
            dailyTrailsList: [],
            FrequencyArray: [],
            isStartSkAq: props.isStartSkAq,
            isSaveSkAq: props.isSaveSkAq,
            secondsElapsedSkAq: props.secondsElapsedSkAq,
            incrementerSkAq: props.incrementerSkAq,
            showTodaysData: false,
            openTargetName: false,
            skillAquisitionTargetsList: [],
            skillAquisitionIndex: [],
            targetName:[],
            startDurationIndex: -1,
            SkillsAcquisitionProgramId: -1,
            newIndexFrequencyArr : undefined,
            modalTitle: '',
            skillsAcquisitionProgramId: null,
            DTTGraphModalOpen: false,
            TAGraphModalOpen: false,
            FrequencyGraphModalOpen: false,
            DurationGraphModalOpen: false,
            selectedIndex:-1,
            postData: [],
            raiseAlertCount:0
      };

        this.filter = {
            sort_Column: '',
            sort_Order: '',
            searchText: '',
        };
        this.handleNewRequest = this.handleNewRequest.bind(this);
        this.handleNewRequests = this.handleNewRequests.bind(this);       
        this.onChangeHandler = this.onChangeHandler.bind(this);              
        this.deletePreviousTrial = this.deletePreviousTrial.bind(this);
        this.onTargetGraphClickHandler = this.onTargetGraphClickHandler.bind(this);              
    }

    componentWillMount = () => {
        this.loadData();
        this.loadPromtCodes();
        this.props.getPatientSkillAcqTaskAnalysislist(this.state.patientId);
        this.props.selectedProgramForTargetAction(this.state.patientId, this.props.ProgramIds);
    };

  componentWillUnmount = () => {
    this.props.isRecordDurationRenderTrueSkAq(false);
  };

  componentWillReceiveProps(nextProps) {
    if ( nextProps.savePatSkillsAcquisitionCollectedData && nextProps.savePatSkillsAcquisitionCollectedData !== this.props.savePatSkillsAcquisitionCollectedData) {
      this.props.dispatch(change("SkillAcqActiveTargetsForm", this.state.promptCodeNameId, false));
    }

    if (nextProps.savedPatSkillsAcquisitionCollectedFrequencyData && nextProps.savedPatSkillsAcquisitionCollectedFrequencyData !== this.props.savedPatSkillsAcquisitionCollectedFrequencyData ) {
        let FrequencyArrayCopy = [];
        if(this.state.newIndexFrequencyArr !== undefined && this.state.newIndexFrequencyArr !== null){
            FrequencyArrayCopy = [...this.state.FrequencyArray];
            FrequencyArrayCopy[this.state.newIndexFrequencyArr] = 0;
        }
       

      this.setState({FrequencyArray: FrequencyArrayCopy},
        () => {this.props.dispatch(change("SkillAcqActiveTargetsForm", this.state.FrequencyArray, FrequencyArrayCopy));}
      );
    }

    // if (nextProps.skillAquisitionActiveProgramsList && nextProps.skillAquisitionActiveProgramsList.length > 0 && this.props.skillAquisitionActiveProgramsList !== nextProps.skillAquisitionActiveProgramsList && this.props.isRecordDurationRenderFlagTrueSkAq) 
    // {
    if (nextProps.skillAquisitionActiveProgramsList && nextProps.skillAquisitionActiveProgramsList.length > 0 && nextProps.skillAquisitionActiveProgramsList !== undefined && this.props.isRecordDurationRenderFlagTrueSkAq && this.state.startDurationIndex === -1) {
      
      let clickedData = this.state.isStartSkAq;
      let saveData = this.state.isSaveSkAq;
      let counterData = this.state.secondsElapsedSkAq;
      let skillAquisitionActiveProgramsList = nextProps.skillAquisitionActiveProgramsList;
      

      skillAquisitionActiveProgramsList.map((obj, index) => {
        return saveData[index] = false;
      });

      skillAquisitionActiveProgramsList.map((obj, index) => {
        return clickedData[index] = false;
      });

      skillAquisitionActiveProgramsList.map((obj, index) => {
        return counterData[index] = 0;
      });

      this.setState({
        isStartSkAq: clickedData,
        isSaveSkAq: saveData,
        secondsElapsedSkAq: counterData,
      });
    }
  }

    loadData = (page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_Order || '',
            contain_filters: {
                patientId: this.state.patientId,
                skillsAcquisitionProgramIds: this.state.selectedActiveProgramIds,
                searchText: this.filter.searchText || null
            },
            pageNumber: page_number || 1,
        };

        this.props.PatientSkillAcqActiveTargetListNewFlow(searchObj)
    }

    alertRaiserFromModal = ()=>{
        this.setState({openTaskAnalysisModal:false})
        Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
              displayComponent: true,
              handleButtonClick: ()=> {
                Alert.closeAll()
                this.setState({openTaskAnalysisModal: true})

        },
              // id: obj.id,
            },
          });
    }

    postDataGetter = (postData)=>{
        this.setState({postData: postData})
    }

    onSubmitHandler = (formProps) => {
        Alert.closeAll()
        let authData = {
            "id": 0,
            "skillsAcquisitionProgramId": this.state.targetObj.skillsAcquisitionProgramId,
            "skillsAcquisitionTargetId": this.state.targetObj.skillsAcquisitionTargetId,
            "patientId": this.state.patientId,
            "sessionId": this.props.uuid,
            "sessionDate": this.state.creadteDate,
            "patientPromptCodeId": null,
            "score": null,
            "patientCollectedDataTaskAnalysisModel": this.state.postData,
            "statusId": 0
        }
        this.setState({
            postData: []
        },()=>this.props.savePatientSkillsAcquisitionCollectedData(authData,'TA')); 
        delay(()=> this.loadData(),200)       
    }


    handleNewRequest(input, value) {
        input.onChange(value);
        if (value.length > 0) {
            this.setState({
                selectedActiveProgramIds: value
            }, () => {
                this.props.SetProgramIDsForSkillAcqTargetAction(value),
                this.loadData()
            })
        }
        else {
            this.setState({
                selectedActiveProgramIds: this.props.ProgramIds
            }, () => {
                    this.props.SetProgramIDsForSkillAcqTargetAction(this.props.ProgramIds)
                    this.loadData()
            })
        }
    }

    loadPromtCodes = () => {
        let searchObj = {
            contain_filters: { patientId: this.state.patientId || null },
            pageNumber: 1,
        };
        this.props.getPatientPromptCodeListToCollectData(searchObj, false);
    }

    handleViewClick = (data, targetId) => {               
        if(targetId > 0) {
            let ObjTargetsList = this.props.skillAquisitionActiveTargetsList.filter((op) => op.id === targetId);
            let filteredSteps = [];
            if (this.props.patientSkillAcqTaskAnalysisList !== null && this.props.patientSkillAcqTaskAnalysisList.data.PatientSkillsAcqTaskAnalysis.length > 0) {
                let data = this.props.patientSkillAcqTaskAnalysisList.data.PatientSkillsAcqTaskAnalysis
                filteredSteps = data.filter((obj, index) => {
                    return obj.skillsAcquisitionTargetId === ObjTargetsList[0].skillsAcquisitionTargetId;
                })
            }
            if (ObjTargetsList[0].targetType.toUpperCase() === "DTT") {
                this.setState({
                    openDttModal: true,
                    openTaskAnalysisModal: false,
                    openTargetInstructionModal: false,
                    skillsAcquisitionProgramId: ObjTargetsList[0].skillsAcquisitionProgramId,
                    targetObj: ObjTargetsList[0],
                    statusId: ObjTargetsList[0].statusId
                })
            }
            else if (ObjTargetsList[0].targetType.toUpperCase() === "TASK ANALYSIS") {

                this.setState({
                    openDttModal: false,
                    // openTaskAnalysisModal: true,
                    openTargetInstructionModal: false,
                    skillsAcquisitionProgramId: ObjTargetsList[0].skillsAcquisitionProgramId,
                    targetObj: ObjTargetsList[0],
                    filteredSteps: filteredSteps,
                    statusId: ObjTargetsList[0].statusId
                }
            )
            
            delay(()=>{
                if(this.state.targetObj.isDataCollectedInDailySummaryData){
                    this.alertRaiserFromModal(null)
                }else{
                    this.setState({
                        openTaskAnalysisModal: true
                    })
                }
            },200)
           
            } else {
                return;
            }
        }
    }


    onTargetGraphClickHandler = (e, Obj, type, index) => {
        console.log("type",type,"---index",index);
        if (type.toUpperCase() === "DTT") {
            console.log("DTT");
            this.setState({
                    selectedIndex:index,
                    DTTGraphModalOpen: true,
                    TAGraphModalOpen: false,
                    FrequencyGraphModalOpen: false,
                    DurationGraphModalOpen: false,
                    modalTitle: Obj.programName,
                    skillsAcquisitionProgramId: Obj.id
            });
        }else if(type.toUpperCase() === "TASK ANALYSIS" ){
            console.log("TASK ANALYSIS");
            this.setState({
                selectedIndex:index,
                DTTGraphModalOpen: false,
                TAGraphModalOpen: true,
                FrequencyGraphModalOpen: false,
                DurationGraphModalOpen: false,
                modalTitle: Obj.programName,
                skillsAcquisitionProgramId: Obj.id
            });
        } else if(type.toUpperCase() === "FREQUENCY" ){
            console.log("FREQUENCY");
            this.setState({
                selectedIndex:index,
                DTTGraphModalOpen: false,
                TAGraphModalOpen: false,
                FrequencyGraphModalOpen: true,
                DurationGraphModalOpen: false,
                modalTitle: Obj.programName,
                skillsAcquisitionProgramId: Obj.id
            });
        } else if(type.toUpperCase() === "DURATION" ){
            console.log("DURATION");
            this.setState({
                selectedIndex:index,
                DTTGraphModalOpen: false,
                TAGraphModalOpen: false,
                FrequencyGraphModalOpen: false,
                DurationGraphModalOpen: true,
                modalTitle: Obj.programName,
                skillsAcquisitionProgramId: Obj.id
            });
        }   
    }

    handleViewTargetInstructionClick = (data, index) => {         
        this.setState({
            openTargetInstructionModal: true,
            openDttModal: false,
            openTaskAnalysisModal: false,
            targetInstructionDetails: (this.state.targetInstructions && this.state.targetInstructions[index] || this.state.programInstructions && this.state.programInstructions[index]),
        })    
    }

    handleClose = () => {
        this.setState({
            selectedIndex:-1,
            openTodaysDTTDataModal: false,
            openDttModal: false,
            openTaskAnalysisModal: false,
            openTodaysTADataModal: false,
            openTargetInstructionModal: false,
            openTodaysDataModal: false,
            openTargetName:false,
            DTTGraphModalOpen:false,
            TAGraphModalOpen: false,
            FrequencyGraphModalOpen: false,
            DurationGraphModalOpen: false,
        })
    }

    handleTodaysDTTData = () => {
        this.setState({
            openTodaysDTTDataModal: true,
            openDttModal: false,
            openTaskAnalysisModal: false,
            openTodaysTADataModal: false,
            openTargetInstructionModal: false,
        });
    }

    setSortColumn = (col_name, col_order) => {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_Order = col_order;
            this.loadData();
        }
    }

    handleTodaysTAData = () => {
        this.setState({
            openTodaysDTTDataModal: false,
            openDttModal: false,
            openTaskAnalysisModal: false,
            openTodaysTADataModal: true,
            openTargetInstructionModal: false,
        });
    }

    handleTodaysData = () => {
        this.setState({showTodaysData: !this.state.showTodaysData})
    }


    handleReset = () => {
        this.setState({
            selectedActiveProgramIds: this.props.ProgramIds
        }, () => {
            // console.log(selectedActiveProgramIds,"selectedActiveProgramIds")
            this.loadData(),
            this.props.dispatch(change("SkillAcqActiveTargetsForm", "ProgramNameForSession", null ))
        })
    }

    editTargetHandler = (index, skillAquisitionTargetsList) => {
        this.setState({
            openTargetName: true,
            skillAquisitionIndex: index,
            skillAquisitionTargetsList: skillAquisitionTargetsList
        })
    }

    handleNewRequests = (input, selectedRecord, index) => {
        
        input.onChange(selectedRecord.value);        
        let skillAquisitionTarget = this.props.skillAquisitionActiveTargetsList.filter((op) => op.id === selectedRecord.value);
        let statusName = this.state.statusName;
        let targetType = this.state.targetType;
        let targetName = this.state.targetName;
        let targetId = this.state.targetId;
        let sd = this.state.sd;
        let targetInstructions = this.state.targetInstructions;
        let programInstructions = this.state.programInstructions;
        let todayCompletedTrails = this.state.todayCompletedTrails;
        let desiredDailyTrials = this.state.desiredDailyTrials;
        let prevData = this.state.prevData;
        let skillAquisitionTargetId = this.state.skillAquisitionTargetId;
        let dailyTrailsList = this.state.dailyTrailsList;
        

        if(skillAquisitionTarget && skillAquisitionTarget.length > 0) {
               //console.log('skillAquisitionTarget............',skillAquisitionTarget)         
            // this.setState({           
            //     status: skillAquisitionTarget[0].status,
            //     targetType: skillAquisitionTarget[0].targetType
            // })
            if(this.state.startDurationIndex >= 0 && this.props.secondsElapsedSkAq[this.state.startDurationIndex] > 0 && this.state.SkillsAcquisitionProgramId === skillAquisitionTarget[0].skillsAcquisitionProgramId){
                this.handleStop(this.state.startDurationIndex)
                this.handleSave(0, this.state.startDurationIndex, skillAquisitionTarget[0].skillsAcquisitionProgramId)
            }
            
            var arr = [];
            for(var i=0; i < this.props.skillAquisitionActiveProgramsList.length; i++) {                
                if(!targetType[i] && targetType.length < this.props.skillAquisitionActiveProgramsList.length) {
                    
                    statusName.push(null);
                    targetType.push(null);
                    targetName.push(null);
                    targetId.push(null);
                    sd.push(null);
                    targetInstructions.push(null);
                    programInstructions.push(null);            
                    todayCompletedTrails.push(null);
                    desiredDailyTrials.push(null);    
                    prevData.push(null);      
                    skillAquisitionTargetId.push(null);                   
                    dailyTrailsList.push(null);
                }
            }

            statusName.splice(index, 1);            
            statusName.splice(index, 0, skillAquisitionTarget[0].status);

            targetType.splice(index, 1);
            targetType.splice(index, 0, skillAquisitionTarget[0].targetType);
            
            targetName.splice(index, 1);
            targetName.splice(index, 0, skillAquisitionTarget[0].targetName);

            targetId.splice(index, 1);
            targetId.splice(index, 0, skillAquisitionTarget[0].id);

            sd.splice(index, 1);
            sd.splice(index, 0, skillAquisitionTarget[0].sd);
            
            targetInstructions.splice(index, 1);
            targetInstructions.splice(index, 0, skillAquisitionTarget[0].targetInstructions);

            programInstructions.splice(index, 1);
            programInstructions.splice(index, 0, skillAquisitionTarget[0].programInstructions);

            skillAquisitionTargetId.splice(index, 1);
            skillAquisitionTargetId.splice(index, 0, skillAquisitionTarget[0].skillsAcquisitionTargetId);
            
            // _.update(statusName, `[${index}]`, function (n) {
            //     return skillAquisitionTarget[0].status;
            // });

            // _.update(targetType, `[${index}]`, function (n) {
            //     return skillAquisitionTarget[0].targetType;
            // });

            // <DTTModal
            //             patientId={this.state.patientId}
            //             uuid={this.props.uuid}
            //             statusId={this.state.statusId}
            //             creadteDate={this.state.creadteDate}
            //             closeDialog={() => this.handleClose()}
            //             promptCodeListData={this.props.promptCodeListData}
            //             targetObj={this.state.targetObj}
            //         />
            if(skillAquisitionTarget[0].targetType.toUpperCase() === "DTT") {

                this.setState({
                    openDttModal: false,
                    openTaskAnalysisModal: false,
                    openTargetInstructionModal: false,
                    skillsAcquisitionProgramId: skillAquisitionTarget[0].skillsAcquisitionProgramId,
                    targetObj: skillAquisitionTarget[0],
                    statusId: skillAquisitionTarget[0].statusId
                },()=>{
                    this.props.dispatch(change('SkillAcqActiveTargetsForm', `targetInstructions[${index}]`, (this.state.targetInstructions && this.state.targetInstructions[index] || this.state.programInstructions && this.state.programInstructions[index])));
                    this.props.getPatientSkillAcqPreviousTrialistNewFlow(this.state.patientId, this.props.uuid, skillAquisitionTarget[0].skillsAcquisitionTargetId);
                });

            } else if(skillAquisitionTarget[0].targetType.toUpperCase() === "FREQUENCY") {

                this.setState({
                    openDttModal: false,
                    openTaskAnalysisModal: false,
                    openTargetInstructionModal: false,
                    skillsAcquisitionProgramId: skillAquisitionTarget[0].skillsAcquisitionProgramId,
                    targetObj: skillAquisitionTarget[0],
                    statusId: skillAquisitionTarget[0].statusId
                },()=>{
                    this.props.dispatch(change('SkillAcqActiveTargetsForm', `targetInstructionsFrequency[${index}]`, (this.state.targetInstructions && this.state.targetInstructions[index] || this.state.programInstructions && this.state.programInstructions[index])));
                });
                
            } else if(skillAquisitionTarget[0].targetType.toUpperCase() === "DURATION"){
                  this.setState({ 
                    openDttModal: false,
                    openTaskAnalysisModal: false, 
                    openTargetInstructionModal: false, 
                    skillsAcquisitionProgramId: skillAquisitionTarget[0].skillsAcquisitionProgramId, 
                    targetObj: skillAquisitionTarget[0], 
                    statusId: skillAquisitionTarget[0].statusId},
                  () => {this.props.dispatch(change("SkillAcqActiveTargetsForm",`targetInstructionsDuration[${index}]`,(this.state.targetInstructions &&this.state.targetInstructions[index]) ||(this.state.programInstructions &&this.state.programInstructions[index])));});
            } 
          
        }
        else {
            statusName[index] = null;
            targetType[index] = null;
            targetName[index] = null;
            targetId[index] = null;
            sd[index] = null;
            targetInstructions[index] = null;
            programInstructions[index] = null;
            skillAquisitionTargetId[index] = null;
        }
        this.setState({openTargetName:false, targetName:targetName, statusName: statusName, targetType: targetType, targetId: targetId, sd: sd, targetInstructions: targetInstructions, programInstructions: programInstructions, skillAquisitionTargetId: skillAquisitionTargetId });
        
      }

      renderPreviousTrial = (prevData) => {
        //console.log('prevData after...........',prevData)
        return (
            <span key={prevData.id}>&nbsp;{prevData.previousTrail}</span>
            //prevData.map((Obj, index) => {
            //    return <span key={index}>&nbsp;{Obj.previousTrail}</span>
            //})
        )
    }

    alertRaiserFromSaveFreq = (value, index)=>{
        Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
              displayComponent: true,
            //handleButtonClick:()=> this.handleSaveFrequency(index, skillsAcquisitionProgramId),
            // id: obj.id,
            handleButtonClick :()=>this.freuencyClickHandler(value,index)
            },
          });
    }

    alertRaiserFromSave = (id, index, skillsAcquisitionProgramId)=>{
        Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
              displayComponent: true,
              handleButtonClick: ()=>this.handleStart(index, skillsAcquisitionProgramId),
              // id: obj.id,
            },
          });
    }

    alertRaiserFromHandleOnchangeHandler = (input, obj, index, i, tindex, skillsAcquisitionProgramId)=>{
        if(input.target.checked){
            Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
                position: 'bottom-right',
                effect: 'slide',
                timeout: 10000,
                customFields: {
                  displayComponent: true,
                  handleButtonClick: ()=>this.onChangeHandler(input, obj, index, i, tindex, skillsAcquisitionProgramId),
                  // id: obj.id,
                },
              });
        }
        else{
            this.onChangeHandler(input, obj, index, i, tindex, skillsAcquisitionProgramId)
        }
       
    }


    onChangeHandler = (input, obj, index, i, targetId, skillsAcquisitionProgramId) => {
        Alert.closeAll();
        if(input.target.checked === true) {
            let authData = {
                "id": 0,
                "skillsAcquisitionProgramId": skillsAcquisitionProgramId, //this.state.targetObj.skillsAcquisitionProgramId,
                "skillsAcquisitionTargetId": this.state.skillAquisitionTargetId[index],
                "patientId": this.state.patientId,
                "sessionId": this.props.uuid,
                "sessionDate": this.state.creadteDate,
                "patientPromptCodeId": obj.promptCodeId,
                "score": obj.scoreAsIndependent === true ? 1 : 0,
                "patientCollectedDataTaskAnalysisModel": [],
                "statusId": this.state.statusId
            }         
            // console.log('targetId.................',targetId)
            // console.log('this.state.targetObj.................',this.state.targetObj)
            
            // console.log('this.state.targetObj.skillsAcquisitionTargetId.................',this.state.targetObj.skillsAcquisitionTargetId)
            
            this.setState({promptCodeNameId:`Prompt[${index}_${i}_${targetId}].promptCodeName`},()=>{                
                this.props.savePatientSkillsAcquisitionCollectedData(authData, this.state.patientId, this.props.uuid,this.state.skillAquisitionTargetId[index],'DTT');
            });            
        }

        delay(()=>this.loadData(),200);
    }

    
    deletePreviousTrial = (index) => {
        //this.props.getPatientSkillAcqPreviousTrialistNewFlow(this.state.patientId, this.props.uuid, this.state.skillAquisitionTargetId[index]);        
        if(this.state.skillAquisitionTargetId[index] > 0) {
            // console.log('index.....',index)        
            // console.log('skillAquisitionTargetsList.....',skillAquisitionTargetsList)
            //let collectedDataId = this.props.patientSkillAcqActiveTargetList[0].id;            
            this.props.deletePatientSkillAcqPreviousTrial_NewFlow(this.state.patientId, this.props.uuid, this.state.creadteDate, this.state.skillAquisitionTargetId[index])
        }
    }

    handleExpandRow=(rowid) => {
        if(this.refs['auth' + rowid] != undefined) {
            let display = this.refs['auth' + rowid].style.display;
            if (display === 'none') {
            this.refs['auth' + rowid].style.display = 'table-row';
            this.refs['authClass' + rowid].className = 'fa fa-minus';
            } else {
            this.refs['auth' + rowid].style.display = 'none';
            this.refs['authClass' + rowid].className = 'fa fa-ellipsis-h';
            }
        }
      };

      freuencyClickHandler = (type, index) => {
        Alert.closeAll()
        const feqValue = this.state.FrequencyArray; 
        
        const feqValueClone = [...feqValue];

        if(feqValueClone[index] > 0) {
            feqValueClone[index] = feqValueClone[index];
        } else {
            feqValueClone[index] = 0;
        }
        if(type === "Minus" && feqValueClone[index] > 0) {
            feqValueClone[index] = feqValueClone[index] - 1;
        } else if(type === "Plus"){
            feqValueClone[index] = feqValueClone[index] + 1;       
        }
        this.setState({
            FrequencyArray: feqValueClone
        })
    }

    handleSaveFrequency = (index, skillsAcquisitionProgramId) => {
        Alert.closeAll()
        this.setState({newIndexFrequencyArr:index});
        let finalData = [];
        let currentData = {
            'sessionDate': this.state.creadteDate,
            'patientId': this.state.patientId,
            'actionString': this.state.targetType[index].toUpperCase(),
            'recordingTypeName': this.state.targetType[index].toUpperCase(),
            };
        finalData.push(currentData)

        let authData = {
            "id": 0,
            "staffId": 0,
            "patientId": this.state.patientId,
            "sessionId": this.props.uuid,
            "sessionDate":  this.state.creadteDate,
            'value': this.state.FrequencyArray[index],
            'skillsAcquisitionTargetId': this.state.targetId[index],
            'duration': null,
            'skillsAcquisitionProgramId': skillsAcquisitionProgramId,
            "patientSkAcqBehaviorRawDataDetails": finalData
        }
    
        this.props.SavePatientRecordFrequencyData(authData)
        delay(()=>this.loadData(),200)
    }


handleStart = (index, skillsAcquisitionProgramId) => {
    Alert.closeAll()
    this.props.isRecordDurationStartSkAq(index, true);
    let isStartSkAq = this.state.isStartSkAq;
    isStartSkAq[index] = true;
    this.setState({
        isStartSkAq: isStartSkAq,
        startDurationIndex: index,
        SkillsAcquisitionProgramId: skillsAcquisitionProgramId,
    },()=>{});
  };

  handleStop = (index) => {
    let isStartSkAq = this.state.isStartSkAq;
    let isSaveSkAq = this.state.isSaveSkAq;
    let counterData = this.state.secondsElapsedSkAq
    isStartSkAq[index] = false;
    isSaveSkAq[index] = true;
    // counterData[index];
    this.setState({
        isStartSkAq: isStartSkAq,
      isSaveSkAq: isSaveSkAq,
      secondsElapsedSkAq: counterData
    }, () => {clearInterval(this.state.incrementerSkAq[index]), clearInterval(this.props.newIncrementerSkAq[index])});
  };

  handleCancel = (index) => {
    Alert.closeAll();
    let clickedData = this.state.isStartSkAq;
    let isSaveSkAq = this.state.isSaveSkAq;
    let counterData = this.state.secondsElapsedSkAq
    clickedData[index] = false;
    isSaveSkAq[index] = false;
    counterData[index] = 0;
    this.setState({
        isStartSkAq: clickedData,
      isSaveSkAq: isSaveSkAq,
      secondsElapsedSkAq: counterData
    }, () => {clearInterval(this.state.incrementerSkAq[index]), clearInterval(this.props.newIncrementerSkAq[index])});
  };

  handleCancelConfirmation = (index) => {
    alertConfirmation("Are you sure you want to cancel Duration Details?", {
      customFields: {
        displayComponent: true,
        handleButtonClick: () => this.handleCancel(index),
      },
    });
  };

  handleSave = (id, index, skillsAcquisitionProgramId) => {
    Alert.closeAll()
    let minutes = Math.floor(this.props.secondsElapsedSkAq[index] / 60);    
    let seconds = Math.floor(this.props.secondsElapsedSkAq[index] % 60);
    if (seconds < 10) {
        seconds = `0${seconds}`
    }
    let duration = minutes+"."+seconds
    let finalData = [];
    let currentData = {
      sessionDate: this.state.creadteDate,
      patientId: this.state.patientId,
      actionString: this.state.targetType[index].toUpperCase(),
      recordingTypeName: this.state.targetType[index].toUpperCase(),
    };
    finalData.push(currentData);

    let authData = {
      id: 0,
      staffId: 0,
      patientId: this.state.patientId,
      sessionId: this.props.uuid,
      sessionDate: this.state.creadteDate,
      duration: duration,
      skillsAcquisitionTargetId: this.state.targetId[index],
      //duration: null,
      skillsAcquisitionProgramId: skillsAcquisitionProgramId,
      patientSkAcqBehaviorRawDataDetails: finalData,
    };

    this.props.SavePatientRecordDurationData(authData);
    let clickedData = this.state.isStartSkAq;
    let isSaveSkAq = this.state.isSaveSkAq;
    let counterData = this.state.secondsElapsedSkAq;
    counterData[index] = 0;
    clickedData[index] = false
    isSaveSkAq[index] = false
    this.setState({
            isStartSkAq: clickedData,
            isSaveSkAq: isSaveSkAq,
            secondsElapsedSkAq: counterData
        }, () => {clearInterval(this.state.incrementerSkAq[index]), clearInterval(this.props.newIncrementerSkAq[index])});
       delay(()=>this.loadData(),200)
    };

    getSeconds = (index) => {
        return ('0' + this.state.secondsElapsedSkAq[index] % 60).slice(-2)
    }

    getMinutes = (index) => {
        return Math.floor(this.state.secondsElapsedSkAq[index] / 60)
    }

    renderData = (patientSkillAquisitionActiveProgramsList) => {
        patientSkillAquisitionActiveProgramsList = patientSkillAquisitionActiveProgramsList || [];
        if (!patientSkillAquisitionActiveProgramsList.length) {
            return (
                <tr>
                    <td colSpan="6">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        const tableClass1 = classNames({
            'table': true,
            'middletable': true,
            // 'customtable': true,
            // 'colorChange': false,
          });
        const tableClass2 = classNames({
            'table': true,
            'childtable': true,
          });
        // <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
        const actions = [
          <CancelButton className="mr-15" onTouchTap={this.handleClose} />
        ];

       

        let todayCompletedTrails = this.state.todayCompletedTrails, desiredDailyTrials = this.state.desiredDailyTrials, prevData = this.state.prevData, dailyTrailsList = this.state.dailyTrailsList;
        let skillAquisitionTargetId = this.state.skillAquisitionTargetId;        
        //let todayCompletedTrails = this.state.todayCompletedTrails, desiredDailyTrials = this.state.desiredDailyTrials, prevData = this.state.prevData;
        //prevData: prevData, todayCompletedTrails: todayCompletedTrails, desiredDailyTrials: desiredDailyTrials
        

        return patientSkillAquisitionActiveProgramsList.map((Obj, index) => {
            
            //console.log('this.props.patientSkillsAcqDailyTrails............',this.props.patientSkillsAcqDailyTrails, dailyTrailsList, index)
            if(this.props.patientSkillsAcqDailyTrails && this.props.patientSkillsAcqDailyTrails.length > 0){
                //console.log('this.props.patientSkillsAcqDailyTrails...after.........',this.props.patientSkillsAcqDailyTrails)
                dailyTrailsList[index] = this.props.patientSkillsAcqDailyTrails.filter((xp) => xp.skillsAcquisitionTargetId === skillAquisitionTargetId[index])[0] || null;
           // console.log('this.props.patientSkillsAcqDailyTrails.filter((xp) => xp.skillsAcquisitionTargetId === skillAquisitionTargetId[index])............',this.props.patientSkillsAcqDailyTrails.filter((xp) => xp.skillsAcquisitionTargetId === skillAquisitionTargetId[index]))
            }            
            else {
                dailyTrailsList = [];
            }
            // console.log('this.props.patientSkillAcqActiveTargetList............',this.props.patientSkillAcqActiveTargetList, prevData)
            if(this.props.patientSkillAcqActiveTargetList !== false && this.props.patientSkillsAcqDailyTrails && this.props.patientSkillsAcqDailyTrails.length > 0) {      
                //console.log('this.props.patientSkillAcqActiveTargetList....after........',this.props.patientSkillAcqActiveTargetList)          
                prevData[index] = this.props.patientSkillAcqActiveTargetList.filter((x) => x.skillsAcquisitionTargetId === skillAquisitionTargetId[index])[0];                
            }
            else {
                prevData = [];
            }

            // console.log('prevData............',prevData);
            // console.log('dailyTrailsList............',dailyTrailsList);
            if(dailyTrailsList && dailyTrailsList.length > 0) {   
                               
                todayCompletedTrails[index] = dailyTrailsList[index] ? dailyTrailsList[index].todayCompletedTrails : null;
                desiredDailyTrials[index] = dailyTrailsList[index] ? dailyTrailsList[index].desiredDailyTrials : null;
                //console.log('this.props.patientSkillsAcqDailyTrails[0]............',this.props.patientSkillsAcqDailyTrails[0])
            }
            else{
                todayCompletedTrails = [];
                desiredDailyTrials = [];
            }            
            // console.log('Obj............',Obj)            
            // console.log('this.props.patientSkillsAcqDailyTrails............',this.props.patientSkillsAcqDailyTrails)
            
            // console.log('skillAquisitionTargetId[index]............',skillAquisitionTargetId[index])
            // console.log('prevData............',prevData, (prevData[index] && prevData[index][0].skillsAcquisitionTargetId))
            //  console.log('todayCompletedTrails............',todayCompletedTrails)      
            //  console.log('desiredDailyTrials............',desiredDailyTrials)
            
            // let skillAquisitionTargetsList = this.props.skillAquisitionActiveTargetsList.filter((op) => op.skillsAcquisitionProgramId === Obj.skillsAcquisitionProgramId);
            return (
                <tr key={index}>
                    <td colSpan="8">
                        <table className={tableClass1}>
                            <tbody>
                                <tr>
                                    <td width="5%">
                                        <button onClick={(e) => this.handleExpandRow(Obj.skillsAcquisitionProgramId)} type="button" className="morebtn">
                                        <i ref={'authClass' + Obj.skillsAcquisitionProgramId} className="fa fa-ellipsis-h" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                    <td width="25%">
                                        {Obj.programName && Obj.programName.length > 0 ?
                                            <Tooltip Description={Obj.programName} />
                                            : null}
                                        {Obj.programName != null && Obj.programName.length > 25 ? SubString(Obj.programName, 25) : Obj.programName != null ? Obj.programName : 'N/A'}
                                    </td>
                                    <td width="32%">
                                        <RaisedButton
                                        label="Target Name"
                                        primary={true}
                                        onTouchTap={() => this.editTargetHandler(index,(this.props.skillAquisitionActiveTargetsList.filter((op) => op.skillsAcquisitionProgramId === Obj.skillsAcquisitionProgramId)))} />
                                    </td>                        
                                    {/* <td width="10%" style={{textAlign: 'center'}}>{((this.state.targetInstructions && this.state.targetInstructions[index]) || (this.state.programInstructions && this.state.programInstructions[index])) ? 
                                                <button onClick={() => this.handleViewTargetInstructionClick(Obj, index)} type="button" title="Target Instructions" className="tbactionbtn bluefont"><i className="fa fa-file-text" aria-hidden="true"></i></button> 
                                                : null}
                                    </td>        */}
                                    {/* <td width="15%">{this.state.targetInstructions && this.state.targetInstructions[index] || this.state.programInstructions && this.state.programInstructions[index]}</td>        */}
                                    <td width="8%">{this.state.targetName && this.state.targetName[index] ? this.state.targetName[index] : ''}</td>             
                                    <td width="8%">{this.state.statusName && this.state.statusName[index] ? this.state.statusName[index] : ''}</td>       
                                    <td width="9%">{this.state.targetType && this.state.targetType[index] ? this.state.targetType[index] : ''}</td>
                                    <td width="5%" style={{textAlign: "center"}}>
                                        {(this.state.targetType && this.state.targetType[index])?(
                                            <button type="button" onClick={(e) => this.onTargetGraphClickHandler(e, Obj, this.state.targetType[index],index)} title="Graph" className="tbactionbtn bluefont"><i className="fa fa-line-chart" aria-hidden="true"></i></button>
                                        ):''}
                                    </td>                                         
                                    <td width="8%" style={{textAlign: 'center'}}>
                                        {this.state.targetType && this.state.targetType[index] && this.state.targetType[index].toUpperCase() === "TASK ANALYSIS" && 
                                            <button onClick={() => this.handleViewClick(Obj, (this.state.targetId && this.state.targetId[index] ? this.state.targetId[index] : 0))} type="button" title="Collect Data" className="tbactionbtn bluefont"><i className="fa fa-file-text" aria-hidden="true"></i></button>
                                        } 
                                    </td>
                                </tr>
                                {this.state.openTargetName && <Dialog 
                                className="custom_modal_new_appointment"
                                title="Target Name"
                                modal={false} open={this.state.openTargetName} autoScrollBodyContent={true}
                                actions={actions}
                                >                                    
                                <div className="mt-30">
                                    <Field
                                        name={`Target[${this.state.skillAquisitionIndex}].targetId`}
                                        hintText='Target Name'
                                        handleNewRequest={(input, selectedRecord) => this.handleNewRequests(input, selectedRecord, this.state.skillAquisitionIndex)}
                                        options={this.state.skillAquisitionTargetsList}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                                </Dialog>}
                                {this.state.targetType && this.state.targetType[index] && this.state.targetType[index].toUpperCase() === "DTT" && 
                                    <tr className="nohover" ref={'auth' + Obj.skillsAcquisitionProgramId} >
                                        <td colSpan="7">                                             
                                            <table className={tableClass2}>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            {/* <button onClick={() => this.handleViewClick(Obj, (this.state.targetId && this.state.targetId[index] ? this.state.targetId[index] : 0))} type="button" title="Collect Data" className="tbactionbtn bluefont"><i className="fa fa-file-text" aria-hidden="true"></i></button> */}
                                                            <div className="row mt-20">
                                                                <div className="col-sm-12">
                                                                    {/* <form className="readmin-form custom_form">                                                                         */}
                                                                        <div className="row mt-10">
                                                                            <div className='col-sm-12'>
                                                                            <span><b>SD :</b>&nbsp;{this.state.sd && this.state.sd[index] ? this.state.sd[index] : ''}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row mt-10">
                                                                            <div className='col-sm-12'>
                                                                            <span><b>Instructions :</b></span>                                                                            
                                                                            {/* <span style={{ display: 'block', wordWrap: 'break-word'}}>{this.state.targetInstructions && this.state.targetInstructions[index] || this.state.programInstructions && this.state.programInstructions[index]}</span> */}
                                                                            </div>
                                                                            <div className='col-sm-12'>
                                                                                <Field
                                                                                    name={`targetInstructions[${index}]`}
                                                                                    //name="targetInstructions"
                                                                                    disabled={true}
                                                                                    type="text"
                                                                                    fullWidth={true}
                                                                                    //label="Subjective"
                                                                                    component={renderTextArea}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        {desiredDailyTrials[index] &&                                                                         
                                                                            <div className="row mt-10">
                                                                                <div className='col-sm-12 mt-10'>
                                                                                    <span><b>Trials Done :</b> {todayCompletedTrails[index]} out of {desiredDailyTrials[index]}</span>                                       
                                                                                </div>
                                                                            </div>    
                                                                        }
                                                                        {prevData[index]  && 
                                                                            <div className="row">                                                                               
                                                                                <div className='col-sm-12 mt-10'>
                                                                                    <span><b>Previous Trial :</b></span>
                                                                                    {this.renderPreviousTrial(prevData[index])}
                                                                                </div>
                                                                            </div>                                
                                                                        }                            
                                                                        <div className="row mt-10" style={{ marginLeft: '0px' }}> 
                                                                            {
                                                                                this.props.promptCodeListData && this.props.promptCodeListData.data &&                                                                                 
                                                                                this.props.promptCodeListData.data.filter((obj) => obj.dtt === true).map((obj, i) => {
                                                                                    return (
                                                                                        <div className="col-sm-6 mt-10" key={i}>
                                                                                            <Field 
                                                                                            className="mt20 mb0"
                                                                                            id={`Prompt[${index}_${i}_${this.state.targetId[index]}].promptCodeName`}
                                                                                            onChange={(input) => {

                                                                                                let flag = false;
                                                                                                this.props.skillAquisitionActiveTargetsList.map(element => {

                                                                                                    if (this.state.targetName[index] === element.targetName) {
                                                                                                        if (element.isDataCollectedInDailySummaryData) {
                                                                                                            flag = element.isDataCollectedInDailySummaryData
                                                                                                        }
                    
                                                                                                    }

                                                                                                });
                                                                                                if (flag) {
                                                                                                    this.alertRaiserFromHandleOnchangeHandler(input, obj, index, i, this.state.targetId[index], Obj.skillsAcquisitionProgramId)
                                                                                                }
                                                                                                else {
                                                                                                    this.onChangeHandler(input, obj, index, i, this.state.targetId[index], Obj.skillsAcquisitionProgramId)
                                                                                                }
                                                                                            }}    
                                                                                            name={`Prompt[${index}_${i}_${this.state.targetId[index]}].promptCodeName`}
                                                                                            label={obj.promptCodeName}
                                                                                            component={renderCheckBox}
                                                                                            checked={false}
                                                                                            disabled={this.props.addPermissionSkillAquisition ? false : true}
                                                                                            // //checked
                                                                                            value={false}
                                                                                            />
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>   
                                                                        <div className="row mt-10" style={{ marginLeft: '0px' }}> 
                                                                            <RaisedButton
                                                                                className="mt-20"
                                                                                style={{ float: 'right' }}
                                                                                label="Delete Previous Trial"
                                                                                disabled={prevData[index] ? (this.props.deletePermissionSkillAquisition ? false : true) : true}
                                                                                primary={true}
                                                                                onTouchTap={() => this.deletePreviousTrial(index)} />
                                                                        </div>   

                                                                    {/* </form> */}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                }
                                {this.state.targetType && this.state.targetType[index] && this.state.targetType[index].toUpperCase() === "FREQUENCY" && 
                                    <tr className="nohover" ref={'auth' + Obj.skillsAcquisitionProgramId} >
                                        <td colSpan="6">   
                                            <table className={tableClass2}>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div className="row mt-10">
                                                                <div className='col-sm-12'>
                                                                <span><b>SD :</b>&nbsp;{this.state.sd && this.state.sd[index] ? this.state.sd[index] : ''}</span>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-10">
                                                                <div className='col-sm-12'>
                                                                <span><b>Instructions :</b></span>                                                                            
                                                                {/* <span style={{ display: 'block', wordWrap: 'break-word'}}>{this.state.targetInstructions && this.state.targetInstructions[index] || this.state.programInstructions && this.state.programInstructions[index]}</span> */}
                                                                </div>
                                                                <div className='col-sm-12'>
                                                                    <Field
                                                                        name={`targetInstructionsFrequency[${index}]`}
                                                                        //name="targetInstructions"
                                                                        disabled={true}
                                                                        type="text"
                                                                        fullWidth={true}
                                                                        //label="Subjective"
                                                                        component={renderTextArea}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>   
                                                            <div className='row'>
                                                                <div className="col-sm-2"> </div>
                                                                <div className="col-sm-1 txtAlignRight">
                                                                    <button
                                                                        name={`freuencyMinus${index}`}
                                                                        className="tableadd"
                                                                        title="Minus"
                                                                        type="button"
                                                                        onClick={() => this.freuencyClickHandler("Minus",index)}
                                                                        >
                                                                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                                                                    </button>
                                                                </div>
                                                                <div className="col-sm-2 txtAlignCenter">{this.state.FrequencyArray[index] || 0}</div>
                                                                <div className="col-sm-1">
                                                                    <button
                                                                        name={`freuencyPlus${index}`}
                                                                        className="tableadd"
                                                                        title="Plus"
                                                                        type="button"
                                                                        // onClick={() => this.freuencyClickHandler("Plus", index)}
                                                                        onClick={() =>{
                                                                            let flag = false;
                                                                            this.props.skillAquisitionActiveTargetsList.map(element => {

                                                                                if (this.state.targetName[index] === element.targetName) {
                                                                                    if (element.isDataCollectedInDailySummaryData) {
                                                                                        flag = element.isDataCollectedInDailySummaryData
                                                                                    }

                                                                                }

                                                                            });
                                                                            if(flag && this.state.raiseAlertCount===0){
                                                                                this.alertRaiserFromSaveFreq("Plus", index)
                                                                                this.setState({raiseAlertCount:1})
                                                                             }
                                                                             else{
                                                                                 this.freuencyClickHandler("Plus", index)
                                                                             }
                                                                        }}
                                                                        >
                                                                        <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                                                                    </button>
                                                                </div>
                                                                <div className="col-sm-3">
                                                                    <RaisedButton
                                                                        style={{ marginRight: '22px', float: 'right' }}
                                                                        label="SAVE"
                                                                        primary={true}
                                                                        disabled={this.props.addPermissionSkillAquisition ? false : true}
                                                                        onTouchTap={() =>{
                                                                            // let flag = false;
                                                                            // this.props.skillAquisitionActiveTargetsList.map(element => {

                                                                            //     if (this.state.targetName[index] === element.targetName) {
                                                                            //         if (element.isDataCollectedInDailySummaryData) {
                                                                            //             flag = element.isDataCollectedInDailySummaryData
                                                                            //         }

                                                                            //     }

                                                                            // });
                                                                            // if(flag){
                                                                            //     this.alertRaiserFromSaveFreq(index, Obj.skillsAcquisitionProgramId)
                                                                            //  }
                                                                            //  else{
                                                                            //      this.handleSaveFrequency(index, Obj.skillsAcquisitionProgramId)
                                                                            //  }
                                                                            this.handleSaveFrequency(index, Obj.skillsAcquisitionProgramId)
                                                                        }}                                                                    /> 
                                                                </div>
                                                            </div>   
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>                                    
                                        </td>
                                    </tr>
                                }
                                {this.state.targetType && 
                                  this.state.targetType[index] &&
                                  this.state.targetType[index].toUpperCase() === "DURATION" && (
                                    <tr
                                      className="nohover"
                                      ref={"auth" + Obj.skillsAcquisitionProgramId}
                                    >
                                      <td colSpan="6">
                                        <table className={tableClass2}>
                                          <tbody>
                                            <tr>
                                                <td colSpan={2}>
                                                    <div className="row mt-10">
                                                        <div className='col-sm-12'>
                                                        <span><b>SD :</b>&nbsp;{this.state.sd && this.state.sd[index] ? this.state.sd[index] : ''}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-10">
                                                        <div className='col-sm-12'>
                                                        <span><b>Instructions :</b></span>                                                                            
                                                        {/* <span style={{ display: 'block', wordWrap: 'break-word'}}>{this.state.targetInstructions && this.state.targetInstructions[index] || this.state.programInstructions && this.state.programInstructions[index]}</span> */}
                                                        </div>
                                                        <div className='col-sm-12'>
                                                            <Field
                                                                name={`targetInstructionsDuration[${index}]`}
                                                                //name="targetInstructions"
                                                                disabled={true}
                                                                type="text"
                                                                fullWidth={true}
                                                                //label="Subjective"
                                                                component={renderTextArea}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                              <td width="20%">
                                                {this.state.isStartSkAq[index] || this.state.isSaveSkAq[index] ? <Timer index={index} /> : '0:00'}
                                              </td>
                                              <td width="80%">
                                                <div className="row">
                                                  <div className="col-sm-12 btn_lt reset-btn mt-10">
                                                    {this.state.isStartSkAq[index] === false &&
                                                      this.state.isSaveSkAq[index] === false && (
                                                        <RaisedButton
                                                          label="START"
                                                          className="startButton"
                                                          primary={true} 
                                                          disabled={this.props.addPermissionSkillAquisition ? false : true}
                                                          onTouchTap={() =>{
                                                            let flag=false
                                                            this.props.skillAquisitionActiveTargetsList.map(element => {
                                                                if (this.state.targetName[index] === element.targetName) {
                                                                    if (element.isDataCollectedInDailySummaryData) {
                                                                        flag = element.isDataCollectedInDailySummaryData
                                                                    }

                                                                }
                                                                })

                                                                 if(flag){
                                                                    this.alertRaiserFromSave(Obj.id, index, Obj.skillsAcquisitionProgramId)
                                                                   
                                                                 }
                                                                 else{
                                                                    this.handleStart(index, Obj.skillsAcquisitionProgramId)
                                                                 }
                                                          }
                                                            
                                                          }
                                                        />
                                                      )}
                                                    {this.state.isStartSkAq[index] === true &&
                                                      this.state.isSaveSkAq[index] === false && (
                                                        <div>
                                                          <span>
                                                            <RaisedButton
                                                              label="STOP"
                                                              className="stopButton"
                                                              primary={true}
                                                              onTouchTap={() =>
                                                                this.handleStop(index)
                                                              }
                                                            />
                                                          </span>
                                                          <span style={{ marginLeft: "20px" }}>
                                                            <RaisedButton
                                                              label="CANCEL"
                                                              className="cancelButton"
                                                              primary={true}
                                                              onTouchTap={() =>
                                                                
                                                                this.handleCancelConfirmation(
                                                                  index
                                                                )
                                                              }
                                                            />
                                                          </span>
                                                        </div>
                                                      )}
                                                    {this.state.isSaveSkAq[index] === true && (
                                                      <div>
                                                        <span>
                                                          <RaisedButton
                                                            label="SAVE"
                                                            primary={true}
                                                            // onTouchTap={() =>
                                                            //   this.handleSave(Obj.id, index, Obj.skillsAcquisitionProgramId)
                                                            // }
                                                            onTouchTap={() =>{
                                                                    this.handleSave(Obj.id, index, Obj.skillsAcquisitionProgramId)
                                                            }}
                                                          />
                                                        </span>
                                                        <span style={{ marginLeft: "20px" }}>
                                                          <RaisedButton
                                                            label="CANCEL"
                                                            className="cancelButton"
                                                            primary={true}
                                                            onTouchTap={() =>
                                                              this.handleCancelConfirmation(
                                                                index
                                                              )
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  )}
                              </tbody>
                            </table>
                          </td>
                          
                        </tr>
                        
                      );
                    });
                  };

    renderSkillAcqActiveTargetsTabs = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
       
        const { skillAquisitionActiveProgramsList } = this.props;
        let patientSkillAquisitionActiveProgramsList = (skillAquisitionActiveProgramsList) || [];
        return (
            <div className="readmin-panel">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="5%">{/* <span style={{ 'visibility': 'hidden' }}>blank</span>*/}</th>
                                            <th width="25%"><SortingCustom noSort={!patientSkillAquisitionActiveProgramsList.length} setSortColumn={this.setSortColumn} columnName='programName' displayName='Program Name' /></th>
                                            <th width="32%"><SortingCustom noSort={!patientSkillAquisitionActiveProgramsList.length} setSortColumn={this.setSortColumn} columnName='targetName' displayName='Target Name' /></th>
                                            {/* <th width="10%" style={{textAlign: 'center'}}>Instructions</th> */}
                                            <th width="8%">Target Name</th>
                                            <th width="8%">Status</th>
                                            <th width="9%">Target Type</th>
                                            <th width="5%">Action</th>
                                            <th width="8%" style={{textAlign: 'center'}}>Collect Data For TA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(patientSkillAquisitionActiveProgramsList)}
                                    </tbody>
                                </table>
                                        {
                                            this.state.DTTGraphModalOpen &&
                                            <DTTGraphModal
                                                patientId={this.state.patientId}
                                                closeDialog={() => this.handleClose()}
                                                targetType={this.state.targetType[this.state.selectedIndex]}
                                                skillAquisitionTargetId={this.state.skillAquisitionTargetId[this.state.selectedIndex]}
                                                skillsAcquisitionProgramId={this.state.selectedActiveProgramIds[this.state.selectedIndex]}
                                                modalTitle={this.state.targetName[this.state.selectedIndex]}
                                            />
                                        }
                                        {
                                            this.state.TAGraphModalOpen &&
                                            <TAGraphModal
                                                patientId={this.state.patientId}
                                                closeDialog={() => this.handleClose()}
                                                targetType={this.state.targetType[this.state.selectedIndex]}
                                                skillAquisitionTargetId={this.state.skillAquisitionTargetId[this.state.selectedIndex]}
                                                skillsAcquisitionProgramId={this.state.selectedActiveProgramIds[this.state.selectedIndex]}
                                                modalTitle={this.state.targetName[this.state.selectedIndex]}
                                            />
                                        }
                                        {
                                            this.state.FrequencyGraphModalOpen &&
                                            <FrequencyGraphModal
                                                patientId={this.state.patientId}
                                                closeDialog={() => this.handleClose()}
                                                targetType={this.state.targetType[this.state.selectedIndex]}
                                                skillAquisitionTargetId={this.state.skillAquisitionTargetId[this.state.selectedIndex]}
                                                skillsAcquisitionProgramId={this.state.selectedActiveProgramIds[this.state.selectedIndex]}
                                                modalTitle={this.state.targetName[this.state.selectedIndex]}
                                            />
                                        }
                                        {
                                            this.state.DurationGraphModalOpen &&
                                            <DurationGraphModal
                                                patientId={this.state.patientId}
                                                closeDialog={() => this.handleClose()}
                                                targetType={this.state.targetType[this.state.selectedIndex]}
                                                skillAquisitionTargetId={this.state.skillAquisitionTargetId[this.state.selectedIndex]}
                                                skillsAcquisitionProgramId={this.state.selectedActiveProgramIds[this.state.selectedIndex]}
                                                modalTitle={this.state.targetName[this.state.selectedIndex]}
                                            />
                                        }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    render() {
        // console.log("selectedprogramIdsData",this.props.selectedprogramIds?.data)
        return (
            <div>
               <div className="row">
                    <div className="col-sm-3 mt-10">
                        <RaisedButton
                            //style={{ marginTop: '10px', marginLeft: '22px', float: 'left' }}
                            label="Back"
                            primary={true}
                            onTouchTap={() => this.state.showTodaysData === true ? this.setState({showTodaysData: false}) :  this.props.handleBack()} />
                    </div>
                    <div className="col-sm-6 mt-20">
                    {this.props.selectedprogramIds !== null && this.state.showTodaysData === false  && 
                    <Field
                            name="ProgramNameForSession"
                            label="program"
                            handleNewRequest={this.handleNewRequest}
                            options={this.props.selectedprogramIds.data}
                            component={renderAutoCompleteScheduling}
                            fullWidth={true}
                    />}
                           
                    </div>
                    <div className="col-sm-3 mt-10">
                        {this.state.showTodaysData === false  && <RaisedButton
                            className="grey_btn"
                            //style={{ marginTop: '10px', marginRight: '22px', float: 'left' }}
                            label="Reset"
                            primary={true}
                            onTouchTap={() => this.handleReset()} />}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter">                        
                        
                            {this.state.showTodaysData === false && <RaisedButton
                            style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                            label="Today's Data"
                            primary={true}
                            onTouchTap={() => this.handleTodaysData()} />}
                    </div>
                </div>
                {this.state.showTodaysData === true ? 
                <TodaysData 
                patientId={this.state.patientId}
                uuid={this.props.uuid}
                targetObj={this.state.targetObj}
                creadteDate={this.state.creadteDate}
                updatePermissionSkillAquisition = {this.props.updatePermissionSkillAquisition}
                deletePermissionSkillAquisition = {this.props.deletePermissionSkillAquisition}
                // closeDialog={() => this.handleClose()}
                
                /> : this.renderSkillAcqActiveTargetsTabs()}
                
                {
                    this.state.openTodaysDTTDataModal === true &&
                    <TodaysDTTDataModal
                        patientId={this.state.patientId}
                        uuid={this.props.uuid}
                        targetObj={this.state.targetObj}
                        creadteDate={this.state.creadteDate}
                        closeDialog={() => this.handleClose()}
                    />
                }
                 {/* {
                    this.state.openTodaysDataModal === true &&
                    <TodaysDataModal
                        patientId={this.state.patientId}
                        uuid={this.props.uuid}
                        targetObj={this.state.targetObj}
                        creadteDate={this.state.creadteDate}
                        closeDialog={() => this.handleClose()}
                    />
                   
                } */}
                {this.state.openDttModal === true &&
                    <DTTModal
                        patientId={this.state.patientId}
                        uuid={this.props.uuid}
                        statusId={this.state.statusId}
                        creadteDate={this.state.creadteDate}
                        closeDialog={() => this.handleClose()}
                        promptCodeListData={this.props.promptCodeListData}
                        targetObj={this.state.targetObj}
                    />
                }
                {this.state.openTaskAnalysisModal === true &&
                    <TaskAnalysisModal
                        patientId={this.state.patientId}
                        uuid={this.props.uuid}
                        statusId={this.state.statusId}
                        creadteDate={this.state.creadteDate}
                        targetObj={this.state.targetObj}
                        filteredSteps={this.state.filteredSteps}
                        promptCodeListData={this.props.promptCodeListData}
                        addPermissionSkillAquisition = {this.props.addPermissionSkillAquisition}
                        alertRaiserFromModal = {this.alertRaiserFromModal}
                        postDataGetter = {this.postDataGetter}
                        loadData = {this.loadData}
                        closeDialog={() => this.handleClose()} />  
                }
                {
                    this.state.openTodaysTADataModal === true &&
                    <TodaysTADataModal 
                    patientId={this.state.patientId}
                    uuid={this.props.uuid}
                    targetObj={this.state.targetObj}
                    creadteDate={this.state.creadteDate}
                    closeDialog={() => this.handleClose()}
                    />
                }
                {this.state.openTargetInstructionModal === true &&
                    <TargetInstructionModal
                        targetInstructionDetails={this.state.targetInstructionDetails}    
                        targetObj={this.state.targetObj}                  
                        closeDialog={() => this.handleClose()} />
                }

            </div>
        )
    }
}

SkillAcqActiveTargetsNewFlow = reduxForm({
    form: 'SkillAcqActiveTargetsForm',
})(SkillAcqActiveTargetsNewFlow);

function mapStateToProps(state) {
    // console.log('state.patientSkillAcqActiveTarget.saved_PatientSkillsAcquisitionCollectedFrequencyData.................', state.patientSkillAcqActiveTarget.saved_PatientSkillsAcquisitionCollectedFrequencyData)    
    return {
        loading: state.patientSkillAcqActiveTarget.loading,
        patientSkillAcqActiveTargetList: state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList !== null && state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList.data.PatientSkillsAcqPreviousTrail,
        //patientSkillAcqActiveTargetList: state.patientSkillAcqActiveTarget.patientSkillAcqActiveTargetList,
        skillAquisitionActiveProgramsList: state.patientSkillAcqActiveTarget.patientSkillAcqActiveTargetListNewFlow && state.patientSkillAcqActiveTarget.patientSkillAcqActiveTargetListNewFlow.data.SkillAquisitionActivePrograms,
        skillAquisitionActiveTargetsList: state.patientSkillAcqActiveTarget.patientSkillAcqActiveTargetListNewFlow && state.patientSkillAcqActiveTarget.patientSkillAcqActiveTargetListNewFlow.data.SkillAquisitionActiveTargets,
        promptCodeListData: state.patient_prompt_code.promptCodeList,
        patientSkillAcqTaskAnalysisList: state.patientSkillAcqActiveTarget.patientSkillAcqTaskAnalysisList,
        uuid: state.patientSkillAcqActiveProgram.uuid,
        ProgramIds: state.patientSkillAcqActiveProgram.ProgramIds,
        selectedprogramIds: state.patientSkillAcqActiveTarget.selectedProgramForTarget,
        ProgramIdsForTargetListingApplicationState: state.patientSkillAcqActiveProgram.ProgramIdsForTargetListingApplicationState,
        patientSkillsAcqDailyTrails: state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList !== null && state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList.data.PatientSkillsAcqDailyTrails,
        savePatSkillsAcquisitionCollectedData: state.patientSkillAcqActiveTarget.saved_PatientSkillsAcquisitionCollectedData,
        savedPatSkillsAcquisitionCollectedFrequencyData: state.patientSkillAcqActiveTarget.saved_PatientSkillsAcquisitionCollectedFrequencyData,
       
        isRecordDurationRenderFlagTrueSkAq: state.patientSkillAcqActiveTarget.isRecordDurationRenderTrueSkAq,
        isStartSkAq: state.patientSkillAcqActiveTarget.isStartSkAq,
        isSaveSkAq: state.patientSkillAcqActiveTarget.isSaveSkAq,
        secondsElapsedSkAq: state.patientSkillAcqActiveTarget.secondsElapsedSkAq,
        incrementerSkAq: state.patientSkillAcqActiveTarget.incrementerSkAq,
        newIncrementerSkAq: state.patientSkillAcqActiveTarget.newIncrementerSkAq,
        patientSkillDomain: state.patientSkillAcqActiveTarget.patientSkillDomain,
        patientSkillProgram:state.patientSkillAcqActiveTarget.patientSkillProgram,
        patientSkillTarget:state.patientSkillAcqActiveTarget.patientSkillTarget
    };
}
export default connect(mapStateToProps, { PatientSkillAcqActiveTargetListNewFlow, getPatientPromptCodeListToCollectData, getPatientSkillAcqTaskAnalysislist, selectedProgramForTargetAction, SetProgramIDsForSkillAcqTargetAction, getPatientSkillAcqPreviousTrialistNewFlow, savePatientSkillsAcquisitionCollectedData, deletePatientSkillAcqPreviousTrial_NewFlow, SavePatientRecordFrequencyData,isRecordDurationStartSkAq, isRecordDurationRenderTrueSkAq, SavePatientRecordDurationData })(SkillAcqActiveTargetsNewFlow)



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/targetNewFlow.js